import React from 'react';
import { isEmpty, isNil, map } from 'lodash';
import HidingItem from './HidingItem.jsx';

import './HidingItems.scss';

const HidingItems = ({ elements }) => {
    return isNil(elements) || isEmpty(elements) ? (
        <></>
    ) : (
        <div className='hiding-elements-container'>
            {map(elements, (e, idx) => (
                <HidingItem key={idx} element={e} />
            ))}
        </div>
    );
};

export default HidingItems;
